module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.aff22bd9.png";